<div layout="column">
    <div class="smile-field-container" id="{{ parentReply ? '' : 'new-reply' }}">
        <div class="p-relative">
            @if (!commonDataService.isOneTime && replyTemplateService.allReplyTemplates.length && quillEditor) {
                <sb-quill-reply-templates
                    [isTextContent]="true"
                    [quillEditor]="quillEditor"
                    [reply]="ticket.constraints.areReplyAttachmentsAllowed ? newReply : null">
                </sb-quill-reply-templates>
            }
            @if (ticket.constraints.isUserMentioningAllowed) {
                <app-sb-quill-mention
                    [quillEditor]="quillEditor"
                    [usersToMention]="ticket.facebookUsersToMention"
                    [isFacebookMention]="true">
                </app-sb-quill-mention>
            }
            <quill-editor
                id="new-reply-editor"
                class="new-reply-editor"
                [(ngModel)]="newReply.message.html"
                (onContentChanged)="onReplyChanged($event, newReply)"
                (onEditorCreated)="
                    parent.onEditorCreated($event, parentReply ? 'newSubReply' + parentReply.id : 'newReply');
                    onEditorCreated($event)
                "
                [modules]="quillConfig"
                [formats]="['emoji', 'mention']"
                placeholder="{{ 'Write a reply' | translate }}">
            </quill-editor>
        </div>

        <sb-quill-emoji-picker
            (updateQuillSelection)="
                parent.updateQuillSelection(
                    parent.quillEditors[parentReply ? 'newSubReply' + parentReply.id : 'newReply']
                )
            "
            (emojiSelect)="
                parent.replyTemplateManagerService.chooseReplyTemplate({
                    $event: $event.$event,
                    templateText: $event.emoji,
                    quillEditor: parent.quillEditors[parentReply ? 'newSubReply' + parentReply.id : 'newReply'],
                    quillRange: parent.quillRange,
                    isSmile: true,
                })
            ">
        </sb-quill-emoji-picker>
    </div>

    <div class="content-attachments-wrapper">
        @for (
            attachment of newReply.attachments | filterContentAttachments: true : newReply.attachments.length;
            track attachment;
            let idx = $index
        ) {
            <div class="content-attachments-block">
                <button
                    type="button"
                    class="btn btn-icon btn-close btn-transparent"
                    aria-label="Close"
                    (click)="deleteGifAttachment(attachment)">
                    <sb-inline-svg
                        class="icon icon-close"
                        aria-label="My icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
                    </sb-inline-svg>
                </button>
                <sb-file-view
                    [ngClass]="{ 'image-attachment': attachment.attachmentType === attachmentTypeEnum.image }"
                    [isFilePreviewInModal]="true"
                    [attachment]="attachment"
                    [permalink]="ticket.permalink">
                </sb-file-view>
            </div>
        }
    </div>

    @if ((newReply.attachments | filterContentAttachments: false : newReply.attachments.length).length) {
        <div class="attachments-block">
            @for (attachment of newReply.attachments; track attachment; let idx = $index) {
                @if (!attachment.isContentPart) {
                    <sb-file-preview
                        class="file-container"
                        [attachment]="attachment"
                        [fileIndex]="idx"
                        [canBeRemoved]="true"
                        [permalink]="ticket.permalink"
                        [attachments]="newReply.attachments">
                    </sb-file-preview>
                }
            }
            <div class="clearfix"></div>
        </div>
    }

    <div class="mt-2">
        <div class="clearfix"></div>
        <div class="buttons-panel text-end">
            @if (
                ticket.constraints.isGifReplySupported &&
                !(newReply.attachments | filterContentAttachments: true : newReply.attachments.length).length
            ) {
                <sb-giphy-picker
                    (add)="addGifAttachment($event)"
                    [isDisabled]="newReply.attachments.length >= ticket.constraints.maxReplyAttachmentsCount">
                </sb-giphy-picker>
            }
            @if (!commonDataService.isOneTime) {
                <button
                    class="btn btn-icon"
                    (click)="
                        parent.openReplyTemplatesModal(
                            $event,
                            parent.quillEditors[parentReply ? 'newSubReply' + parentReply.id : 'newReply'],
                            ticket.constraints.areReplyAttachmentsAllowed ? newReply : null
                        )
                    "
                    tooltip="{{ 'Insert a saved template' | translate }}"
                    container="body">
                    <sb-inline-svg class="icon" [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Copy icon.svg'">
                    </sb-inline-svg>
                </button>
            }
            <button
                (click)="parent.setSignature(newReply, parentReply ? parentReply.id : null, $event, false)"
                class="btn btn-icon"
                id="btn-signature"
                #btnSignature
                tooltip="{{ 'Signature' | translate }}"
                container="body">
                <sb-inline-svg class="icon" [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Pen icon.svg'">
                </sb-inline-svg>
            </button>
            @if (ticket.isEditable && ticket.constraints.areReplyAttachmentsAllowed && !parentReply) {
                <button
                    class="btn btn-icon"
                    (click)="
                        parent.openAttachmentsModal(
                            newReply.attachments,
                            newReply.attachments.length,
                            ticket.constraints.maxReplyAttachmentsCount
                        )
                    "
                    tooltip="{{ 'Attachments' | translate }}"
                    container="body"
                    [disabled]="newReply.attachments.length >= ticket.constraints.maxReplyAttachmentsCount">
                    <sb-inline-svg
                        class="icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Attachment icon.svg'">
                    </sb-inline-svg>
                </button>
            }
            @if (ticket.isEditable && ticket.constraints.areReplyAttachmentsAllowed && parentReply) {
                <button
                    class="btn btn-icon"
                    (click)="
                        parent.openAttachmentsModal(
                            newReply.attachments,
                            newReply.attachments.length,
                            ticket.constraints.maxReplyAttachmentsCount
                        )
                    "
                    tooltip="{{ 'Attachments' | translate }}"
                    container="body"
                    [disabled]="newReply.attachments.length >= ticket.constraints.maxReplyAttachmentsCount">
                    <sb-inline-svg
                        class="icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Attachment icon.svg'">
                    </sb-inline-svg>
                </button>
            }
            @if (!commonDataService.isOneTime) {
                <button
                    class="btn mt-1 mb-1 btn-outline"
                    [disabled]="
                        newReply.message | isInvalidMessage: ticket.constraints : !!newReply.attachments.length : false
                    "
                    (click)="
                        isOnlyAutoSignatureSet && addAutoSignature();
                        parent.addReply(newReply, true, false, [], [], [], usersToMention, undefined, parentReply)
                    "
                    translate>
                    save as draft
                </button>
            }
            <button
                class="btn btn-outline"
                [disabled]="
                    newReply.message | isInvalidMessage: ticket.constraints : !!newReply.attachments.length : false
                "
                (click)="
                    isOnlyAutoSignatureSet && addAutoSignature();
                    parent.addReply(newReply, false, false, [], [], [], usersToMention, undefined, parentReply)
                "
                translate>
                send
            </button>
            <button
                class="btn btn-outline"
                [disabled]="
                    newReply.message | isInvalidMessage: ticket.constraints : !!newReply.attachments.length : false
                "
                (click)="
                    isOnlyAutoSignatureSet && addAutoSignature();
                    parent.addReply(newReply, false, true, [], [], [], usersToMention, undefined, parentReply)
                "
                translate>
                send and close
            </button>
        </div>
    </div>
</div>
